// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"56677dd0","439":"14e74abb","658":"b3be9ec9"}[chunkId] + ".chunk.css";
};